import ActivityTypeCreateEditForm from './ActivityTypeCreateEditForm';

export default ActivityTypeCreateEditForm;
